import $ from 'jquery'

import { isMobile } from './isMobile'

const ADDITIONAL_OFFSET = 30

export default {
  scrollToElement(el) {
    const headerHeight = isMobile()
      ? $('.main-nav-mobile').height()
      : $('.main-nav-desktop').height() || 0

    return $('html, body').animate(
      { scrollTop: el.offset().top - headerHeight - ADDITIONAL_OFFSET },
      'slow'
    )
  },

  scrollToTarget(target = '') {
    const hash = target || window.location.hash
    // if there is no hash value we just return
    if (!hash.length) {
      return
    }

    const el = $(hash)
    // if there is no el with id of location hash we just return
    if (!el.length) {
      return
    }

    this.scrollToElement(el)
  },

  bindLocationHash() {
    // respect the initial location hash and scroll to it
    this.scrollToTarget()
    // prevent anchor links from
    $('a[href^="#"]').on('click', event => {
      // Only intercept if we have a target hash pinting to current document
      if (event.target.pathname !== window.location.pathname) {
        return event
      }

      event.preventDefault()
      this.scrollToTarget(event.target.hash)
    })
  },
}
